import _ from 'lodash';
import accounting from 'accounting';
import { REPORT_USERS, REPORT_STATUS_NAME } from 'utils/Constants';

export const pluralize = (count, objectName, suffix = 's') => {
  if (count !== 1) {
    return objectName + suffix;
  }
  return objectName;
};

export const currency = (amount: string) => {
  if (_.isUndefined(amount)) {
    return 'ERROR';
  }
  return `$${amount.toLocaleString('es-US', { maximumFractionDigits: 2 })}`;
};

export const formatCurrency = (
  amount: string,
  precision: number = 0,
  symbol: string = '$'
) => {
  if (_.isUndefined(amount)) {
    return accounting.formatMoney(0, symbol, precision);
  }
  return accounting.formatMoney(amount, symbol, precision);
};

export const getDotColor = (homeStatus: string) => {
  if (homeStatus === 'rented' || homeStatus === 'published') return '#278C7E';
  if (homeStatus === 'rejected') return '#ff0000';
  if (homeStatus === 'reserved') return '#F49C20';
  if (
    [
      'in_progress',
      'hidden',
      'temporarily_canceled_by_posposal',
      'unpublished',
      'temporarily_canceled',
      'pending_approval',
      'waiting_external_photoshooting'
    ].includes(homeStatus)
  )
    return '#cacaca';

  return '#826FFF';
};

export const getStatusText = (homeStatus: string) => {
  if (homeStatus === 'rented') return 'Renta activa';
  if (homeStatus === 'published') return 'Publicado';
  if (homeStatus === 'reserved') return 'Reservado';
  return 'Sin estado';
};

export const getFilterReport = (
  isHiddenDefect: boolean,
  report: any
): boolean => {
  return (
    isHiddenDefect === report.is_hidden_defect &&
    report.status !== 'not_repaired' &&
    report.status !== 'canceled' &&
    !(
      report.report_type === 'diagnostic' &&
      ['requested', 'scheduled', 'visited', 'repaired'].includes(report.status)
    )
  );
};

export const getReportStatusText = (
  userType: number,
  reportType: string,
  status: string
): string => {
  if (REPORT_USERS.TENANT === userType) {
    return REPORT_STATUS_NAME[0][reportType][status] || '';
  }
  if (REPORT_USERS.OWNER === userType) {
    return REPORT_STATUS_NAME[1][reportType][status] || '';
  }

  return REPORT_STATUS_NAME[2][reportType][status] || '';
};
